import React from 'react';

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  EmptyDataTable,
  LinearProgress,
  Card,
  CardContent,
  CardHeader,
} from '@occc-app/design-system';
import { SiteSystemCarWashItem } from '@occc/graphql';

interface ICarWashProps {
  carWashItems?: SiteSystemCarWashItem[];
  loading: boolean;
}

const CarWash: React.FC<ICarWashProps> = ({ carWashItems, loading }) => {
  const renderContent = () => {
    if (!loading && (!carWashItems || carWashItems.length === 0)) {
      return <EmptyDataTable />;
    }

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell align='right'>Unit Price</TableCell>
            <TableCell align='right'>Merchandise Code</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {carWashItems &&
            carWashItems.map((carWash, i) => {
              return (
                <TableRow key={i}>
                  <TableCell>{carWash.description}</TableCell>
                  <TableCell align='right'>{carWash.unitPrice}</TableCell>
                  <TableCell align='right'>{carWash.merchandiseCode}</TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    );
  };

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardHeader title={<Typography variant='h6'>Car Wash</Typography>} />
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
};

export default CarWash;
